(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[557],{

/***/ "fMZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SearchGlass", function() { return SearchGlass; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var SearchGlass = function SearchGlass(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 19 19"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M7.4 0C3.3 0 0 3.3 0 7.4c0 4.1 3.3 7.4 7.4 7.4 1.6 0 3-.5 4.2-1.3l5.1 5.1c.5.5 1.3.5 1.9 0 .5-.5.5-1.3 0-1.9l-5.1-5.1c.8-1.2 1.3-2.7 1.3-4.2.1-4.1-3.3-7.4-7.4-7.4zm0 2.6c2.7 0 4.8 2.1 4.8 4.8s-2.1 4.8-4.8 4.8c-2.7 0-4.8-2.1-4.8-4.8s2.2-4.8 4.8-4.8z"
  }));
};

/***/ })

}]);